import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '../store';

import {RouterConfig} from '@config';

Vue.use(VueRouter);

// Layouts
import DefaultLayout from '@layouts/Default.vue';
import FullscreenLayout from '@layouts/Fullscreen.vue';

//private
import Dashboard from '@views/private/Dashboard.vue';
import Accounts from '@views/private/Accounts.vue';
import Declarations from '@views/private/Declarations.vue';
import Chat from '@views/private/Chat.vue';
import ChatOverview from '@views/private/ChatOverview.vue';
import RequestDetail from '@views/private/RequestDetail.vue';
import Today from '@views/private/Today.vue';
import Agenda from '@views/private/Agenda.vue';

//public
import Login from '@views/public/Login.vue';
import PasswordForget from '@views/public/PasswordForget.vue';
import PasswordForgetSuccess from '@views/public/PasswordForgetSuccess.vue';
import Register from '@views/public/Register.vue';
import Verification from '@views/public/Verification.vue';
import VerificationCode from '@views/public/VerificationCode.vue';
import RenewPassword from '@views/public/RenewPassword.vue';
import RenewPasswordSuccess from '@views/public/RenewPasswordSuccess.vue';

// Views
import NotFound from '@views/NotFound.vue';
import Forbidden from '@views/Forbidden.vue';

const router = new VueRouter({
    mode: RouterConfig.mode || 'history',
    routes: [{
        path: '',
        component: DefaultLayout,
        children: [
            {
                path: '/',
                component: Dashboard,
                name: 'dashboard',
                meta: {
                    title: ($route) => 'Aanvragenoverzicht',
                    private: true,
                    topbar: true,
                    button: ($route, user) => {
                        return (user && (user.is_applicant || user.is_planner)) ? {
                            text: 'Nieuwe aanvraag',
                            event: 'toggle-new-request'
                        } : null;
                    },
                    module: 'requests'
                }
            },{
                path: '/accounts',
                component: Accounts,
                name: 'accounts',
                meta: {
                    title: ($route) => 'Accounts',
                    private: true,
                    topbar: true,
                    access: {
                        is_planner: false,
                        is_management: true,
                        is_administratie: false,
                        is_applicant: false,
                        is_translator: false
                    },
                    module: 'accounts'
                }
            }, {
                path: '/geen-toegang',
                component: Forbidden,
                name: 'forbidden',
                meta: {
                    private: true,
                    topbar: true,
                    title: ($route) => 'Geen toegang',
                }
            }, {
                path: '/vandaag',
                component: Today,
                name: 'today',
                meta: {
                    title: ($route) => 'Vandaag',
                    private: true,
                    topbar: true,
                    access: {
                        is_planner: true,
                        is_management: true,
                        is_administratie: true,
                        is_applicant: false,
                        is_translator: false
                    },
                    module: 'today'
                }
            },{
                path: '/declaraties',
                component: Declarations,
                name: 'declarations',
                meta: {
                    title: ($route) => 'Declaraties',
                    private: true,
                    topbar: true,
                    button: ($route, user) => {
                        return {
                            text: 'Exporteer',
                            target: '_blank',
                            href: '/declaraties/export/'
                        }
                    },
                    access: {
                        is_planner: false,
                        is_management: false,
                        is_administratie: true,
                        is_applicant: false,
                        is_translator: false
                    },
                    module: 'declarations'
                }
            }, {
                path: 'agenda',
                component: Agenda,
                name: 'agenda',
                meta: {
                    title: ($route) => 'Agenda',
                    private: true,
                    topbar: false,
                    access: {
                        is_planner: true,
                        is_management: true,
                        is_administratie: true,
                        is_applicant: false,
                        is_translator: false
                    },
                    module: 'agenda'
                }
            },{
                path: '/berichten',
                component: () => import('@views/private/Messages.vue'),
                name: 'messages',
                meta: {
                    title: ($route) => 'Berichtencentrum',
                    private: true,
                    topbar: true,
                    module: 'messages'
                }
            },{
                path: '/aanvragen/:id',
                component: RequestDetail,
                name: 'request-detail',
                meta: {
                    title: ($route) => store.getters['request/kenmerk'] || $route.params.id,
                    breadcrumb: [
                        'dashboard'
                    ],
                    private: true,
                    topbar: false,
                    module: 'requests'
                }
            }, {
                path: '/aanvragen/:id/chat',
                component: Chat,
                name: 'chat',
                meta: {
                    title: ($route) => 'Berichtencentrum',
                    breadcrumb: [
                        'dashboard',
                        'request-detail'
                    ],
                    private: true,
                    topbar: false,
                    module: 'requests'
                }
            }, {
                path: '/aanvragen/:id/chat-overzicht',
                component: ChatOverview,
                name: 'chat-overview',
                meta: {
                    title: ($route) => 'Berichtencentrum',
                    breadcrumb: [
                        'dashboard',
                        'request-detail'
                    ],
                    private: true,
                    topbar: false,
                    module: 'requests'
                }
            }
        ]
    }, {
        path: '',
        component: FullscreenLayout,
        children: [
            {
                path: '/login',
                component: Login,
                name: 'login',
                meta: {
                    title: ($route) => 'Inloggen',
                    private: false
                }
            }, {
                path: '/wachtwoord-vergeten',
                component: PasswordForget,
                name: 'password-forget',
                meta: {
                    title: ($route) => 'Wachtwoord vergeten',
                    private: false
                }
            }, {
                path: '/wachtwoord-vergeten/succes',
                component: PasswordForgetSuccess,
                name: 'password-forget-success',
                meta: {
                    title: ($route) => 'Je wachtwoord is aangepast',
                    private: false
                }
            }, {
                path: '/activeren/:token',
                component: Register,
                name: 'activate',
                meta: {
                    title: ($route) => 'Activeren',
                    private: false
                }
            }, {
                path: '/tweestapsverificatie',
                component: Verification,
                name: 'verification',
                meta: {
                    title: ($route) => 'Registreren Tweestapsverificatie',
                    private: false,
                    authenticator: true,
                }
            }, {
                path: '/tweestapsverificatie/code',
                component: VerificationCode,
                name: 'verification-qr',
                meta: {
                    title: ($route) => 'Registreren Tweestapsverificatie QR',
                    private: false,
                    authenticator: true,
                }
            }, {
                path: '/wachtwoord-vernieuwen/:token',
                component: RenewPassword,
                name: 'renew-password',
                meta: {
                    title: ($route) => 'Wachtwoord aanpassen',
                    private: false
                }
            }, {
                path: '/wachtwoord-vernieuwen/succes',
                component: RenewPasswordSuccess,
                name: 'renew-password-success',
                meta: {
                    title: ($route) => 'Je wachtwoord is aangepast',
                    private: false
                }
            }, {
                path: '*',
                component: NotFound,
                name: 'not-found',
                meta: {
                    title: ($route) => 'Pagina niet gevonden',
                    private: false
                }
            }
        ]
    }],
    scrollBehavior(to, from, savedPosition) {
        return {x: 0, y: 0}
    }
});

export default router;
